import React from 'react'
import { LaTercera } from '@labcon/copesa-logos'
import LogoRanking from '../Hero/LogoRankingUniversidades2023'
import { Link } from 'gatsby'

import Ad from '@/components/Ads/Header'
import ITT from '@/components/Ads/ITT'
import styled from 'styled-components'

const StyledHeader = styled.header`
  backdrop-filter: saturate(110%) blur(10px);
  background-color: rgba(0, 0, 0, 0.4);
  &:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: -1;
    background-image: linear-gradient(
      135deg,
      #f5f5dc,
      #ffddca,
      #ffd1ac,
      #fbcba3,
      #f8b88b,
      #f3a76c,
      #f0a58f,
      #ece0d1
    );
    opacity: 0.6;
  }
  .container {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
  }
`

const Header = () => (
  <>
    <StyledHeader className="fixed top-0 left-0 right-0 z-20 items-center justify-center border-gray-300 border-solid shadow-md">
      <div className="container h-16 px-2 mx-auto sm:px-4 lg:px-20">
        <div className="p-2">
          <Link to="/" className="flex items-center justify-start h-10 ">
            <LogoRanking
              theme="dark"
              alt="Ranking de las Universidades 2023"
              className="block w-32 h-10"
            />
          </Link>
        </div>
        <div className="p-2">
          <a
            target="_blank"
            className="flex items-center justify-end h-10 "
            href="https://www.latercera.com/?utm_source=landingbienvenida&utm_medium=web&utm_campaign=logo-latercera&utm_content=logo-latercera-header">
            <LaTercera
              schema="light"
              className="sm:h-5 sm:w-40 "
              width="200"
              height="20"
            />
          </a>
        </div>
      </div>
    </StyledHeader>
    {/* <Ad />
    <ITT /> */}
  </>
)

export default Header
